<template>
  <div class="action-panel">
    <div class="action-step">
      <h6>1. Surat Pernyataan</h6>
      <p class="small text-muted">Cetak surat untuk nasabah dan saksi.</p>
      <b-button variant="pgiBtn" :disabled="!canAction || isPrintingSuratPernyataan" @click="onCetakSuratPernyataan">
        <b-spinner v-if="isPrintingSuratPernyataan" small class="mr-1" />
        <i class="fa fa-print mr-2" /> Cetak Surat Pernyataan
      </b-button>
      <small v-if="suratPernyataanPrinted" class="text-success d-block mt-2">
        <i class="fa fa-check-circle mr-1" /> Surat telah dicetak.
      </small>
    </div>

    <div class="action-step">
      <h6>2. Upload Surat</h6>
      <p class="small text-muted">Upload PDF surat bermaterai dan bertanda tangan.</p>
      <div class="upload-gadai-btn-wrapper mt-2">
        <b-button
          v-if="suratPernyataanPublicUrl"
          class="upload-gadai-btn"
          variant="cancelBtn"
          @click="openSuratPernyataanPreview"
        >
          Lihat
        </b-button>
        <div class="browse-foto upload-gadai-btn">
          <b-form-file
            v-model="suratPernyataanFile"
            :state="Boolean(suratPernyataanFile)"
            :disabled="!canAction || isUploadingSuratPernyataan"
            accept=".pdf,application/pdf"
            drop-placeholder="Drop file here..."
            @input="onUploadSuratPernyataanPdf"
            class="hide-upload-label"
          />
          <b-button
            variant="cancelBtn"
            class="upload-gadai-btn"
            :disabled="!canAction || isUploadingSuratPernyataan"
          >
            <i class="fa fa-upload mr-1"></i>
            Upload
          </b-button>
        </div>
      </div>
      <small v-if="suratPernyataanFileName" class="text-muted d-block mt-2">{{ suratPernyataanFileName }}</small>
    </div>

    <div class="action-step mb-0 border-0">
      <h6>3. Penyerahan Tunai</h6>
      <p class="small text-muted">Konfirmasi penyerahan dana tunai.</p>
      <b-button
        variant="success"
        :disabled="!canAction || !hasUploadedSuratPernyataan || isUploadingSuratPernyataan"
        @click="onKonfirmasiPenyerahanTunai"
      >
        <i class="fa fa-check mr-2" /> Konfirmasi Penyerahan Tunai
      </b-button>
      <small v-if="!hasUploadedSuratPernyataan" class="text-muted d-block mt-2">Upload surat terlebih dahulu.</small>
    </div>

    <b-modal id="modal-preview-surat-pernyataan" size="xl" title="Surat Pernyataan Nasabah" ok-only ok-title="Tutup">
      <iframe
        title="Surat Pernyataan Nasabah"
        :src="suratPernyataanPdfUrl"
        width="100%"
        height="650"
        frameborder="0"
      />
    </b-modal>
    <b-modal id="modal-preview-upload-surat-pernyataan" size="xl" title="Preview Surat Pernyataan" ok-only ok-title="Tutup">
      <iframe
        v-if="suratPernyataanPreviewUrl"
        :src="suratPernyataanPreviewUrl"
        class="preview-pdf"
        title="Preview Surat Pernyataan"
      />
    </b-modal>
    <ModalConfirm
      id="modal-confirm-penyerahan-tunai"
      title="Konfirmasi Penyerahan Tunai"
      :isSubmitting="isSubmittingPenyerahanTunai"
      :desc="`Apakah anda yakin menyerahkan dana tunai sebesar Rp. ${formatAmount(diberikanTunai)}?`"
      @submit="onSubmitPenyerahanTunai"
    />
  </div>
</template>

<script>
import { getDiberikanTunai } from './disbursementPendingUtils'

export default {
  name: 'DisbursementPendingStatementAction',
  props: {
    disbursementPending: {
      type: Object,
      default: () => ({}),
    },
    canAction: {
      type: Boolean,
      default: false,
    },
    refreshDetail: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      suratPernyataanPrinted: false,
      isPrintingSuratPernyataan: false,
      suratPernyataanFile: null,
      suratPernyataanPreviewUrl: '',
      suratPernyataanPublicUrl: '',
      suratPernyataanFileName: '',
      isUploadingSuratPernyataan: false,
      isSubmittingPenyerahanTunai: false,
      suratPernyataanPdfUrl: '',
    }
  },
  computed: {
    diberikanTunai() {
      return getDiberikanTunai(this.disbursementPending)
    },
    suratPernyataanPublicUrls() {
      return this.suratPernyataanPublicUrl ? [this.suratPernyataanPublicUrl] : []
    },
    hasUploadedSuratPernyataan() {
      return this.suratPernyataanPublicUrls.length > 0
    },
  },
  methods: {
    formatAmount(value) {
      return this.$helper.addThousandSeparator(value || 0)
    },
    formatSuratPernyataanFileName() {
      return 'Pilih PDF'
    },
    async onCetakSuratPernyataan() {
      const id = this.disbursementPending.gadaiDisbursementId || this.disbursementPending.id

      if (!id) {
        this.$helper.toastErr(this, 'ID disbursement tidak ditemukan.')
        return
      }

      this.isPrintingSuratPernyataan = true

      try {
        const response = await this.$axios.get(`gadai-disburse/${id}/print-statement`)
        this.suratPernyataanPdfUrl = `${this.$baseFilePath}${response.data.name}`
        this.suratPernyataanPrinted = true
        this.$bvModal.show('modal-preview-surat-pernyataan')
      } catch (error) {
        this.$helper.parseError(this, error)
      } finally {
        this.isPrintingSuratPernyataan = false
      }
    },
    async onUploadSuratPernyataanPdf(file) {
      if (!file) return

      if (!this.isPdfFile(file)) {
        this.resetSuratPernyataanUpload()
        this.$helper.toastErr(this, 'File harus berupa PDF.')
        return
      }

      this.isUploadingSuratPernyataan = true
      this.suratPernyataanPublicUrl = ''
      this.suratPernyataanFileName = ''
      this.revokeSuratPernyataanPreview()

      this.$store.dispatch('loading/show', { progress: 0 })
      let response

      try {
        response = await this.$helper.uploadPresigned({
          vue: this,
          path: 'gadai-disburse/create-url',
          params: { fileExtension: this.getFileExtension(file) },
          fileUpload: file,
          contentType: this.getUploadContentType(file),
          onUploadProgress: progress => this.setUploadProgress(progress),
          useXhr: true,
        })
      } catch (error) {
        this.resetSuratPernyataanUpload()
        this.$helper.parseError(this, error)
        return
      } finally {
        this.isUploadingSuratPernyataan = false
        this.$store.dispatch('loading/hide')
      }

      if (!response.success) {
        this.resetSuratPernyataanUpload()
        this.$helper.toastErr(this, 'Gagal upload surat. Silakan coba lagi.')
        return
      }

      this.suratPernyataanPreviewUrl = URL.createObjectURL(file)
      this.suratPernyataanPublicUrl = response.publicUrl
      this.suratPernyataanFileName = file.name
    },
    setUploadProgress(progress) {
      this.$store.dispatch('loading/setProgress', Math.min(progress, 100))
    },
    openSuratPernyataanPreview() {
      if (!this.suratPernyataanPreviewUrl) return

      this.$bvModal.show('modal-preview-upload-surat-pernyataan')
    },
    onKonfirmasiPenyerahanTunai() {
      this.$bvModal.show('modal-confirm-penyerahan-tunai')
    },
    async onSubmitPenyerahanTunai() {
      const id = this.disbursementPending.id

      if (!id) {
        this.$helper.toastErr(this, 'ID disbursement tidak ditemukan.')
        return
      }

      if (!this.hasUploadedSuratPernyataan) {
        this.$helper.toastErr(this, 'Upload surat terlebih dahulu.')
        return
      }

      const payload = {
        pathFotoStatement: this.suratPernyataanPublicUrls,
      }

      this.isSubmittingPenyerahanTunai = true
      let isSubmitted = false

      try {
        await this.$axios.post(`gadai-disburse/${id}/upload-statement`, payload)
        isSubmitted = true

        try {
          await this.refreshDetail()
        } catch (error) {
          this.$helper.parseError(this, error)
        }
      } catch (error) {
        this.$helper.parseError(this, error)
      } finally {
        this.isSubmittingPenyerahanTunai = false
      }

      if (isSubmitted) {
        this.$bvModal.hide('modal-confirm-penyerahan-tunai')
        this.$helper.toastSucc(this, 'Penyerahan uang tunai dikonfirmasi.')
      }
    },
    resetSuratPernyataanUpload() {
      this.revokeSuratPernyataanPreview()
      this.suratPernyataanFile = null
      this.suratPernyataanPublicUrl = ''
      this.suratPernyataanFileName = ''
    },
    revokeSuratPernyataanPreview() {
      if (!this.suratPernyataanPreviewUrl) return

      URL.revokeObjectURL(this.suratPernyataanPreviewUrl)
      this.suratPernyataanPreviewUrl = ''
    },
    getUploadContentType(file) {
      return (file && file.type) || 'application/pdf'
    },
    getFileExtension(file) {
      const name = (file && file.name) || ''
      const extension = name.split('.').pop()
      if (extension && extension !== name) return extension.toLowerCase()

      return 'pdf'
    },
    isPdfFile(file) {
      const type = (file && file.type) || ''
      const name = ((file && file.name) || '').toLowerCase()

      return type === 'application/pdf' || name.endsWith('.pdf')
    },
  },
  beforeDestroy() {
    this.revokeSuratPernyataanPreview()
  },
}
</script>

<style scoped>
.action-panel {
  background: #f8f9fa;
  border: 1px solid #e4e7ea;
  border-radius: 4px;
  padding: 16px;
}

.action-step {
  border-bottom: 1px solid #e4e7ea;
  margin-bottom: 16px;
  padding-bottom: 16px;
}

.upload-gadai-btn-wrapper {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.upload-gadai-btn {
  min-width: 96px;
}

.browse-foto {
  position: relative;
}

.browse-foto .custom-file {
  cursor: pointer;
  height: 34px;
  opacity: 0;
  position: absolute;
  width: 100%;
  z-index: 2;
}

.preview-pdf {
  border: 0;
  height: 75vh;
  width: 100%;
}
</style>
